<template>
  <div class="index" :style="{ paddingTop: statusBar + 'rem' }">
    <Header ref="header" title="重置密码" :back="true" left="" />
    <div class="windowmain">
      <div class="boxmain">
        <div class="boxstep">
          <div class="stepitem stepitemactive" style="flex:0.7">
            <p class="itemp1">1</p>
            <p class="stepline"></p>
            <p class="itemp2">填写用户名</p>
          </div>
            <div class="stepitem stepitemactive" style="flex:0.8">
            <p class="itemp1">2</p>
            <p class="stepline2"></p>
            <p class="itemp2">安全验证</p>
          </div>
           <div class="stepitem stepitemactive" style="flex:0.8">
            <p class="itemp1">3</p>
             <p class="stepline3"></p>
            <p class="itemp2">重置密码</p>
          </div>
           <div class="stepitem stepitemactive" style="flex:0.5">
            <p class="itemp1">4</p>
           
            <p class="itemp2">完成</p>
          </div>
        </div>
        <div class="boxinput">
            <div class="boxend">
               <div class="endImg"><img src="@/views/image/userregister/icon_pass.png" alt="" /></div>
               <div class="endTxt">
                <p class="end_p1">密码重置成功！</p>
                <p  class="end_p2">请妥善保管您的登录密码</p>
                <p  class="end_p3 end_p4">登录用户名：<span>121212121</span></p>    
                <p  class="end_p3 ">新密码：<span>DK111</span></p>   
                </div> 
            </div>
      
           
        
        </div>
      </div>

      <div style="margin: 16px">
        <van-button
          type="primary"
          class="btn1"
          size="large"
          @click="fromSubmit()"
          >重新登录</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>

import Header from "@/components/Header";

import {
  Form,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Field,
  Col,
  Row,
  Button,
  Picker,
  Popup,
  Icon,
    Step,
  Steps,
  Toast,
  DatetimePicker,
  NoticeBar,
} from "vant";

export default {
  name: "swforgotend",
  data() {
    return {
      certName: "",
      certpsd:'',
      cerpsed:"",
      certNo: "",
      ieFlag: "",
       base64img: '',
       pacClientId:'',
      downIcon:true,
      downIcon1:true,
       checkCode: '',
      passdType: 'password',

      bizCode: "FACE_ALIPAY_SDK",
      statusBar: 0,
      value: "",
    };
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
  
  },

  methods: {
    fromSubmit() {},
 
  

    
  },

  components: {
    Header,

    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [DatetimePicker.name]: DatetimePicker,
    [NoticeBar.name]: NoticeBar,
     [Step.name]: Step,
    [Steps.name]: Steps,
     [Icon.name]: Icon,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/public.scss";
@import "@/views/css/userindex.scss";
// ::v-deep .van-cell {
//   display: block;
// }
// ::v-deep .van-cell::after {
//   border-bottom: 0px;
// }

.windowmain {
  width: 100%;
  .boxmain {
    width: 100%;
    .boxTitle {
      font-size: 13px;
      color: #333;
      font-weight: bold;
     margin-bottom: 14px;
    }
     .boxstep{
      width: auto;
      background: #fff;
      height: auto;
      display: flex;
          padding: 14px 11px 16px 11px;
      .stepitem{
        flex:1;
        position: relative;
        text-align: center;
        .stepline{
          position: absolute;
          width:42px;
          height: 1px;
          background: #d5d5d5;
          left: 70px;
    top: 9px;
        }
          .stepline2{
          position: absolute;
          width:50px;
          height: 1px;
          background: #d5d5d5;
          left: 76px;
    top: 9px;
        }
        .stepline3{
          position: absolute;
          width:42px;
          height: 1px;
          background: #d5d5d5;
          left: 70px;
    top: 9px;
        }
        .itemp1{
          width: 17px;
      height: 17px;
      background: #d5d5d5;
      font-size: 11px;
      color:#fff;
          text-align: center;
    border-radius: 50%;
    line-height: 18px;
    display: block;
    position: relative;
    margin: 0 auto;
        }
         .itemp2{
          font-size: 12px;
          color: #999;
          margin-top: 6px;
         }
      }
      .stepitemactive{
        .itemp1{
          background: #00599c;
        }
        .itemp2{
           color: #00599c;
        }
          .stepline {
          background: #00599c;
        }
         .stepline2 {
          background: #00599c;
        }
         .stepline3 {
          background: #00599c;
        }
      }
    }
  }
  .boxinput {
    margin-top: 12px;
    height: auto;
    border-radius: 4px;
    background: #fff;
    padding: 10px 0px;
    .boxend{
      width: 100%;
      text-align: center;
      padding-bottom: 20px;
      .endTxt{
        width: 100%;
        height: auto;
        background-image: url('~@/views/image/userregister/icon_endbg.png');
        background-size: cover;
      }
      .endImg{
        width: 36px;
        height: 36px;
        margin: 20px auto;
        img{
          width: 100%;
        }
      }
      .end_p1,.end_p2{
        font-size: 15px;
        color: #333;
        line-height: 24px;
        font-weight: bold;
      }
      .end_p3{
        font-size: 12px;
        line-height: 18px;
color: #666;
      }
      .end_p4{
        margin-top: 16px;
      }
    }
 
  }



  .ftBton {
    padding: 0px 15px;
    font-size: 11px;
    color: #999;
  }

}
</style>